module.exports = __webpack_public_path__ + "img/img05.c852281c.png";